export default __webpack_public_path__ + "static/academicons-c6027a1f695509e44b7d2d44167319f2.eot";